export default __webpack_public_path__ + "static/media/wegovy-cap-pen.95ff42ce.mp4";